import "../sparkle_namespace.js";

window.Sparkle ??= {};

Sparkle.Tooltips = {
  defaults: {
    touch: false,
    appendTo: "parent",
    delay: [250, 0],
    zIndex: 3,
  },
  lazy: function (element, tooltip, options) {
    jQuery(element).on("mouseenter", function () {
      Sparkle.Tooltips.add(this, tooltip, options);
    });
  },

  add: function (element, tooltip, options) {
    element = jQuery(element);

    // Bail out if we've already added a tooltip
    if (element.data("sparkleTooltip")) {
      return;
    }
    element.data("sparkleTooltip", true);

    // Allow the tooltip to trigger after the framework is loaded, but not to if the user has moused away
    var showAfterFrameworkLoad = true;
    element.one("mouseleave", function () {
      showAfterFrameworkLoad = false;
    });

    // Generate the tooltip contents
    tooltip = tooltip || element.attr("title");
    element.removeAttr("title");

    if (!tooltip) {
      return;
    }

    jQuery.when().then(function () {
      var instance = tippy(element[0], jQuery.extend({}, Sparkle.Tooltips.defaults, options, { content: tooltip }));

      // Now that the library is downloaded, show the tooltip if we're still hovered
      if (showAfterFrameworkLoad) {
        instance.show();
      }
    });
  },
};
